const profileSection = '/profile';

export const ProfilePath = profileSection;
export const ChangePasswordPath = `${profileSection}?action=change-password`;
